import { Component } from '@angular/core';
import { AdminActionsDirective } from '@app/main/admin/directives/admin-actions.directive';
import { DialogService } from '@shared/services';
import { ModuleService } from '@shared/services/module.service';
import { AdminService } from '../../admin.service';

@Component({
    selector: 'app-admin-report',
    templateUrl: './admin-report.component.html',
    styleUrls: ['./admin-report.component.scss'],
    standalone: false
})
export class AdminReportComponent extends AdminActionsDirective {
    constructor(adminService: AdminService, dialogService: DialogService, moduleService: ModuleService) {
        super(adminService, dialogService, moduleService);
    }
}
